import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { Permissions, security } from "Common/permissions";
import size from "lodash/size";
import { connect } from "react-redux";
import { TAB } from "./constants";
import DocumentsSidebarMenu from "./documentsSidebarMenu";
import actionCreators from "./redux/actionCreators";
import { getActiveDocumentType, getIsExpanded, getSelectedMethods, getTab } from "./redux/selectors";
const canViewTasks = security.isAllowed([Permissions.TasksView]);
const canViewMethods = security.isAllowed([Permissions.MethodsView]);
const canViewScripts = security.isAllowed([Permissions.MethodsView]);
const mapStateToProps = (state) => ({
    isExpanded: getIsExpanded(state),
    tabKey: getTab(state),
    sidebarMenuTabsRows: getTab(state) === TAB.METHODS && size(getSelectedMethods(state)) !== 0 ? 3 : 2,
    documentType: getActiveDocumentType(state),
    canViewTasks,
    canViewMethods,
    canViewScripts
});
const mapDispatchToProps = (dispatch) => ({
    onDocumentTypeChanged: (documentType) => {
        if (documentType === DOCUMENT_TYPE.CONTENT)
            dispatch(actionCreators.setTab(TAB.NAVIGATION));
    },
    onExpandedChanged: (isExpanded) => dispatch(actionCreators.setIsExpanded(isExpanded))
});
export default connect(mapStateToProps, mapDispatchToProps)(DocumentsSidebarMenu);
